import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export function useWarehouseByLocation(location_id: number) {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    const locationIdNumber = Number(location_id)
    if (!locationIdNumber || Number.isNaN(locationIdNumber)) {
      setData([])
      setLoading(false)
      return
    }

    setLoading(true)

    api
      .get("/location-warehouse/by-location", {
        params: { location_id: locationIdNumber }
      })
      .then(
        (res: SuccessFetch<{
          payload: {
            location_warehouse_id: number
            warehouse_name: string
          }[]
        }>) => {
          setData(
            res.data.payload.map((item) => ({
              label: item.warehouse_name,
              value: item.location_warehouse_id.toString()
            }))
          )
        }
      )
      .catch(() => {
        setData([])
      })
      .finally(() => {
        setLoading(false)
      })

    return () => {
      setData([])
      setLoading(false)
    }
    // eslint-disable-next-line
  }, [location_id])

  return { data, isLoading }
}
